import Auth_API from "./apiConfig";
// Centralized Error Handling
const handleError = (error) => {
  if (error.response) {
    console.error("Server Error:", error.response.data.message || error.response.statusText);
    throw new Error(error.response.data.message || "Server Error");
  } else if (error.request) {
    console.error("Network Error:", error.message);
    throw new Error("Network Error. Please check your connection.");
  } else {
    console.error("Error:", error.message);
    throw new Error("An unexpected error occurred. Please try again.");
  }
};

export const getAllEvents = async (params) => {
  try {
    const response = await Auth_API.get(`events/user/upcoming-events`, { params });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const getAllServiceCategory = async (params) => {
  try {
    const response = await Auth_API.get(`config/ctype/service_category`, { params });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const getMaintenanceFeaturesList = async (type) => {
  try {
    const response = await Auth_API.post(`config/ctype/${type}`);
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const submitProficornFeedback = async (feedbackData) => {
  try {
    const response = await Auth_API.post(`proficorn/feedback`, feedbackData);
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const updateFcmToken = async (userId="", fcmToken="") => {
  
  try {
    const response = await Auth_API.post(`user/update/${userId}`, { fcm_token: fcmToken });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};
